import React, { useState, useEffect } from "react";
import { IoFunnel } from "react-icons/io5";

import MaintenanceList from "./AlternativeCustomerNamesList";
import MaintenanceFiltersWrapper from "./AlternativeCustomerNamesFiltersWrapper";
import MaintenanceFiltersForm from "./AlternativeCustomerNamesFiltersForm";

import CustomerService from "../../services/customerService";

import { customToast as toast } from "../../utils";

import HeaderWrapper from "../common/HeaderWrapper";

const MaintenancePage = () => {
  const [sorted, setSorted] = useState([{ id: "name", desc: true }]);
  const [filtersOpen, setFiltersOpen] = useState(false);

  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    page: 0,
    pageSize: 20,
    status: [{ label: "Active", value: true }],
    name: [],
    alternative_names: []
  });

  const getFilteredQuery = () => {
    const query = {
      $and: []
    };

    if (filters?.status?.length > 0) {
      query.$and.push({
        $or: filters.status.map((s) => ({ status: s?.value }))
      });
    }
    if (filters?.name?.length > 0) {
      query.$and.push({
        $or: filters.name.map((n) => ({ name: n?.label }))
      });
    }
    if (filters?.alternative_names?.length > 0) {
      query.$and.push({
        $or: filters.alternative_names.map((a_n) => ({
          alternative_names: a_n?.label
        }))
      });
    }

    return query;
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const filtered = getFilteredQuery();

      const { customers, pages } = await CustomerService.getCustomers({
        filtered,
        sort: [],
        pageSize: filters.pageSize,
        page: filters.page
      });

      setTotalPages(pages);
      setData(customers);
      setLoading(false);
    } catch (err) {
      toast.error("Could not fetch data, please contact support");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filters.page || filters.pageSize) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.page, filters.pageSize]);

  const handlePageSizeChange = (pageSize) => {
    setFilters((prev) => ({ ...prev, pageSize }));
  };

  const handlePageChange = async (page) => {
    setFilters((prev) => ({ ...prev, page }));
  };

  const handleSortedChange = async (newSort) => {
    setSorted(newSort);
  };

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleResetClick = () => {
    setFilters({
      page: 0,
      pageSize: 20,
      status: [{ label: "Active", value: true }],
      name: [],
      alternative_names: []
    });
    setData([]);
  };

  const headerActions = [
    {
      action: () => setFiltersOpen(!filtersOpen),
      icon: <IoFunnel />
    }
  ];

  return (
    <React.Fragment>
      <HeaderWrapper
        breadcrumbs={[{ label: `Alternative Customer Names` }]}
        onClickAction={headerActions}
      />

      <MaintenanceFiltersWrapper
        loading={loading}
        filtersOpen={filtersOpen}
        onFetchClick={fetchData}
        onResetClick={handleResetClick}
      >
        <MaintenanceFiltersForm
          filters={filters}
          onChange={handleFilterChange}
        />
      </MaintenanceFiltersWrapper>

      <div className="content-wrapper">
        <MaintenanceList
          data={data}
          loading={loading}
          onClickEdit={() => {}}
          pages={totalPages}
          page={filters.page}
          pageSize={filters.pageSize}
          sorted={sorted}
          setData={(vals) => setData(vals)}
          onPageSizeChange={handlePageSizeChange}
          onPageChange={handlePageChange}
          onSortedChange={handleSortedChange}
        />
      </div>
    </React.Fragment>
  );
};

export default MaintenancePage;
